module.exports = __webpack_public_path__ + "static/media/Figure14.35d628f9.jpg";